import styled from 'styled-components'

import theme from '../../../theme/theme'

export const FormContainer = styled.div`
	padding-top: 1.5em;
	padding-left: 0.5em;
	padding-right: 0.5em;
`